import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import { Box, Button } from '@mui/material';
import { palette } from 'theme/palette';
import { selectPartnerId } from 'selectors/partnerStatusSelector';
import { selectMemberCodeStatus } from 'selectors/memberCodeSelector';
import { LoadingButton } from 'components/common/LoadingButton';
import { revokeMemberCode } from 'services/member-code/revokeMemberCode';
import { setMemberCode } from 'reducers/memberCodeReducer';
import { closeModal, openModal } from 'reducers/modalReducer';
import { MemberCodeOutputStatusEnum } from 'pco-product-service-internal-consumer';
import { setSelectedProduct } from 'reducers/tableReducer';
import { videoIdentificationStyles } from 'views/VideoIdentification/VideoIdentificationFormActions';

export const MemberZoneActions = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const partnerNumber = useSelector(selectPartnerId);
  const memberCodeStatus = useSelector(selectMemberCodeStatus);
  const [isRevokeLoading, setIsRevokeLoading] = useState(false);

  const handleClose = () => {
    dispatch(setSelectedProduct(undefined));
    navigate(`/partner?partnerNumber=${partnerNumber}`);
  };

  const createNewCode = () => {
    dispatch(setSelectedProduct(undefined));
    navigate(`/partner/${partnerNumber}/new/memberCode`);
  };

  const handleRevoke = () => {
    setIsRevokeLoading(true);
    if (partnerNumber)
      revokeMemberCode(partnerNumber)
        .then((code) => {
          dispatch(setMemberCode(code));
        })
        .catch((error) => {
          dispatch(
            openModal({
              modalType: 'JBErrorModalWrapper',
              modalProps: {
                httpError: error,
                okHandler: () => {
                  dispatch(closeModal());
                },
                technicalInfo: {
                  title: 'Error when revoking Member Code',
                  userErrorMessage: 'An error occurred when revoking Member Code. Please try again later.',
                },
              },
            }),
          );
          return 'error';
        })
        .finally(() => setIsRevokeLoading(false));
  };

  return (
    <Box sx={videoIdentificationStyles.actions}>
      <Box
        style={{
          width: '95%',
          display: 'flex',
          justifyContent: 'space-between',
          maxWidth: '95%',
        }}
      >
        {memberCodeStatus === MemberCodeOutputStatusEnum.Activated ? (
          <LoadingButton
            id="revoke-member-code-button-memberzone-action"
            data-testid="revoke-member-code-button-memberzone-action"
            onClick={handleRevoke}
            variant="outlined"
            style={{ color: palette.black }}
            loading={isRevokeLoading}
          >
            Revoke
          </LoadingButton>
        ) : (
          <Button
            id="create-new-member-code-button-memberzone-action"
            data-testid="create-new-member-code-button-memberzone-action"
            onClick={createNewCode}
            variant="outlined"
            style={{ color: palette.black }}
          >
            Create new code
          </Button>
        )}
        <Box
          style={{
            display: 'flex',
            justifyContent: 'flex-end',
          }}
        >
          <Button
            id="close-preview-button-memberzone-action"
            data-testid="close-preview-button-memberzone-action"
            color="primary"
            variant="contained"
            onClick={handleClose}
            disabled={false}
            style={{ marginRight: 0 }}
          >
            Close preview
          </Button>
        </Box>
      </Box>
    </Box>
  );
};
